export function setupCalculator() {
    const calculator = document.querySelector('.module.calculator');

    if (calculator) {
        let terraceArea;
        const productSelector = document.getElementById('productSelector');
        const productImage = document.getElementById('productImage');
        const calculateTriggers = calculator.querySelectorAll('[data-action="calculate"]');
        const updateFields = calculator.querySelectorAll('[data-factor]');
        const lengthField = document.getElementById('deckingLength');
        const widthField = document.getElementById('deckingWidth');
        const m2Field = document.getElementById('deckingM2');
        const deckingAreaText = document.getElementById('deckingArea');
        const printButton = calculator.querySelector('[data-action="print"]');

        const categoryErrorMessage = calculator.getAttribute('data-category-error-message');
        const addressErrorMessage = calculator.getAttribute('data-address-error-message');
        const areaErrorMessage = calculator.getAttribute('Du bedes udfylde længde + bredde eller areal');

        function Terrasseberegner_counter() {
            var xhttp;
            xhttp = new XMLHttpRequest();

            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {}
            };

            xhttp.open("GET", window.location.href + "?terrasseberegner-add-count=1", true);
            xhttp.send();
        }

        function Terrasseberegner_print_result(e) {
            const category = productSelector.options[productSelector.selectedIndex].text;
            const width = widthField.value;
            const length = lengthField.value;
            const navn = document.getElementById('navn').value;
            const adresse = document.getElementById('adresse').value;
            const by = document.getElementById('by').value;
            const telefon = document.getElementById('telefon').value;
            const cvr = document.getElementById('cvr').value;
            const tareal = deckingArea.innerHTML;
            const mm120 = document.getElementById('mm120').innerHTML;
            const mm145 = document.getElementById('mm145').innerHTML;
            const c_45 = document.getElementById('c_45').innerHTML;
            const c50 = document.getElementById('c50').innerHTML;
            const c60 = document.getElementById('c60').innerHTML;
            const uPic = document.getElementById('usage_pic').innerHTML;
            const upic2 = document.getElementById('for_stk').innerHTML;
            const upk = document.getElementById('usage_pk').innerHTML;
            const fPs = document.getElementById('for_ps').innerHTML;
            const cat_img = productSelector.options[productSelector.selectedIndex].value;

            if (cat_img == "") {
                alert(categoryErrorMessage);

                return;
            }

            function print_result() {
                var myWindow = window.open("", "", "fullscreen=yes");
                var myHTML = "";
                myHTML += '<script>var load = 0;</script>';
                myHTML += '<table width="80%" border="0" cellspacing="0" cellpadding="1">';
                myHTML += '<tr>';
                myHTML += '<td ><img src="/Files/images/terracecalculator/logo.jpg" onload="load++;" onerror="load++;" id="topImg" alt=""></td> ';
                myHTML += '</tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" cellspacing="0">';
                myHTML += '<tr>';
                myHTML += '<td>';
                myHTML += '<table width="100%" border="0" cellspacing="0" cellpadding="5">';
                myHTML += '<tr>';
                myHTML += '<th colspan="2" align="left">Indtast Oplysninger</th>';
                myHTML += '</tr>';
                myHTML += '<tr>';
                myHTML += '<td>Navn</td><td>' + navn + '</td> ';
                myHTML += '</tr>';
                myHTML += '<tr>';
                myHTML += '<td>Adresse</td><td>' + adresse + '</td> ';
                myHTML += '</tr>';
                myHTML += '<tr>';
                myHTML += '<td>Postnr. / By</td><td>' + by + '</td> ';
                myHTML += '</tr>';
                myHTML += '<tr>';
                myHTML += '<td>Telefon</td><td>' + telefon + '</td>';
                myHTML += '</tr>';
                myHTML += '<tr>';
                myHTML += '<td>Tømmerhandel</td><td>' + cvr + '</td>';
                myHTML += '</tr>';
                myHTML += '</table>';
                myHTML += '</td>';
                myHTML += '<td style="vertical-align: top;">';
                myHTML += '<table width="100%" border="0" cellspacing="0" cellpadding="5">';
                myHTML += '<tr>';
                myHTML += '<th colspan="2" align="right">Pris på andet tilbehør</th>';
                myHTML += '</tr>';

                if (document.getElementById('check_1').checked == true) {
                    myHTML += '<tr>';
                    myHTML += '<td colspan="2" align="right">Olie</td> ';
                    myHTML += '</tr>';
                }
                if (document.getElementById('check_2').checked == true) {
                    myHTML += '<tr>';
                    myHTML += '<td colspan="2" align="right">Voks</td> ';
                    myHTML += '</tr>';
                }
                if (document.getElementById('check_3').checked == true) {
                    myHTML += '<tr>';
                    myHTML += '<td colspan="2" align="right">Propbor </td> ';
                    myHTML += '</tr>';
                }
                if (document.getElementById('check_4').checked == true) {
                    myHTML += '<tr>';
                    myHTML += '<td colspan="2" align="right">Håndlister </td> ';
                    myHTML += '</tr>';
                }
                if (document.getElementById('check_5').checked == true) {
                    myHTML += '<tr>';
                    myHTML += '<td colspan="2" align="right">Stolper </td> ';
                    myHTML += '</tr>';
                }

                myHTML += '</table>';
                myHTML += '</td>';
                myHTML += '</tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" border="0" cellspacing="0" cellpadding="5">';
                myHTML += '<tr><td colspan="3" align="center"></td></tr>';
                myHTML += '<tr><td rowspan="3" align="center"><img width="200px" id="cat_img" onload="load++;" onerror="load++;" src="' + cat_img + '"><br><br><span >' + category + '</span></td><td>Terrassens Længde</td><td>' + length + '</td></tr>';
                myHTML += '<tr><td>Terrassens Bredde</td><td>' + width + '</td></tr>';
                myHTML += '<tr><td>Areal</td><td>' + terraceArea + '</td></tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" border="1" cellspacing="0" cellpadding="5">';
                myHTML += '<tr align="left"><th>Samlet areal</th><th width="30%">' + tareal + ' m²</th></tr>';
                myHTML += '<tr><td> 120mm/(117mm) </td><td width="30%">' + mm120 + '</td></tr>';
                myHTML += '<tr><td> 145mm </td><td>' + mm145 + '</td></tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" border="1" cellspacing="0" cellpadding="5">';
                myHTML += '<tr><th align="left" colspan="2">Strøer</th></tr>';
                myHTML += '<tr><td> C/C 45cm </td><td width="30%">' + c_45 + '</td></tr>';
                myHTML += '<tr><td> C/C 60cm </td><td>' + c60 + '</td></tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" border="1" cellspacing="0" cellpadding="5">';
                myHTML += '<tr><th align="left" colspan="2">Skruer</th></tr>';
                myHTML += '<tr><td> Forbrug </td><td width="30%">' + uPic + '</td></tr>';
                myHTML += '<tr><td> pk á 200 stk.= </td><td>' + upk + '</td></tr>';
                myHTML += '</table>';
                myHTML += '<table style="margin-bottom:10px;" width="80%" align="center" border="1" cellspacing="0" cellpadding="5">';
                myHTML += '<tr><th align="left" colspan="2">Propper</th></tr>';
                myHTML += '<tr><td> Forbrug </td><td width="30%">' + upic2 + '</td></tr>';
                myHTML += '<tr><td> ps á 500 stk.= </td><td>' + fPs + '</td></tr>';
                myHTML += '<table width="100%"><tr><tr><img src="/Files/images/terracecalculator/footer.jpg" width="100%" onload="load++;" onerror="load++;" id="bottomImg" alt=""></td></tr></table>';
                myHTML += '<script>function printFun() { if(load == 3) { clearInterval(checkLoad); window.print();  } }</script>';
                myHTML += '<script>var checkLoad = setInterval(function(){ printFun(); }, 500);</script>';

                myWindow.document.write(myHTML);
                myWindow.document.close();

                Terrasseberegner_counter();

                return false;
            }

            if (terraceArea != '') {
                if (navn != '' && adresse != '' && by != '' && telefon != '' && cvr != '') {
                    print_result();
                } else {
                    alert(addressErrorMessage);
                }
            } else {
                alert(areaErrorMessage);
            }
        }

        function setFieldValues(terraceArea) {
            const dec = decimalPlaces(terraceArea);

            if (dec > 0) {
                deckingAreaText.textContent = terraceArea.toFixed(2);
            } else {
                deckingAreaText.textContent = terraceArea;
            }

            Array.from(updateFields).forEach(field => {
                const factor = field.getAttribute('data-factor');
                let value = terraceArea * factor;
                let showDecimals = true;

                if (field.hasAttribute('data-pr-piece')) {
                    const prPiece = field.getAttribute('data-pr-piece');
                    value = value / prPiece;
                }

                if (field.hasAttribute('data-disable-decimals')) {
                    showDecimals = false;
                    value = Math.ceil(value);
                }

                field.textContent = showDecimals ? value.toFixed(2) : value;
            });
        }

        function clearFieldValues() {
            deckingAreaText.textContent = '';

            Array.from(updateFields).forEach(field => {
                field.textContent = '';
            });
        }

        function calculate() {
            let length = lengthField.value.replace(',','.');
            let width = widthField.value.replace(',','.');
            const m2 = m2Field.value.replace(',','.');

            if (length != '' && width != '') {
                length = Number(length);
                width = Number(width);

                terraceArea = length * width;
            } else if (m2 != '') {
                terraceArea = Number(m2);
            } else {
                terraceArea = null;
            }

            if (terraceArea) {
                setFieldValues(terraceArea);
            } else {
                clearFieldValues();
            }
        }

        function decimalPlaces(num) {
            const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

            if (!match) {
                return 0;
            }

            return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        }

        if (lengthField && widthField && m2Field && deckingAreaText) {
            Array.from(calculateTriggers).forEach(trigger => {
                trigger.addEventListener('keyup',calculate);
            });
        }

        if (productSelector && productImage) {
            productSelector.addEventListener('change',function() {
                productImage.src = this.options[this.selectedIndex].value;
            });
        }

        if (printButton) {
            printButton.addEventListener('click', Terrasseberegner_print_result);
        }
    }
}